import type { CareGiverLeadFormData } from "~care/types/forms/care-giver-lead-form";
import type { BooleanKeys, StringKeys } from "~care/types/keys";

export const textFields: [
  StringKeys<CareGiverLeadFormData["step2"]>,
  string,
][] = [
  ["FirstName", "First Name"],
  ["LastName", "Last Name"],
  ["Email", "Email"],
];

export const checkboxFields: [
  BooleanKeys<CareGiverLeadFormData["step2"]>,
  string,
][] = [
  [
    "CanWorkInUS",
    "I have documents that establish my identity and eligibility to work in the United States.",
  ],
  [
    "BusinessInEnglish",
    "I can conduct business in written and spoken English.",
  ],
  [
    "ConsentTerms",
    `By submitting this form, I agree to receive emails, marketing and promotional text messages, and automated phone calls from Home Instead and 
      its franchisees at the phone number and email address provided. `,
  ],
];
